import PropTypes from 'prop-types';
import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { TOP_STATIONS_BROWSE_LINK } from '../../constants/MyStations';
import { AsyncDomain } from '../../domains';
import { getInDomain } from '../../domains/externalUtils';

import './MyStationsGenreCategories.scss';

class MyStationsBrowseGenreCategories extends React.Component {
  static propTypes = {
    intl: PropTypes.object.isRequired,
    ApiGetGenreCategories: PropTypes.func.isRequired,
    getBrowseDirectory: PropTypes.func.isRequired,
    genreCategoriesHaveLoaded: PropTypes.bool,
    browseTopStations: PropTypes.object,
  };

  componentDidMount() {
    if (!this.props.browseTopStations) {
      this.props.getBrowseDirectory({ path: TOP_STATIONS_BROWSE_LINK });
    }
  }

  // In the case of a user removing a station, since we clear browse data after removal,
  // we need to call again in case user returns to empty state.
  componentDidUpdate(prevProps) {
    if (prevProps.browseTopStations !== this.props.browseTopStations) {
      this.props.getBrowseDirectory({ path: TOP_STATIONS_BROWSE_LINK });
    }
  }

  render() {
    const BrowseModuleComponent = (
      <AsyncDomain
        domain='discovery'
        key='BrowseModule'
        component='BrowseModule'
        section={this.props.browseTopStations}
        maxItems={5}
      />
    );
    return (
      <div className='MyStationsGenreCategories'>
        <div className='MyStationsGenreCategories__gridContainer'>
          {this.props.browseTopStations && BrowseModuleComponent}
        </div>
      </div>
    );
  }
}

export function mapStateToProps(state) {
  const browseTopStations = getInDomain('discovery.selectors.getBrowseDeepLevelDirectoryByUrl')(
    state,
    TOP_STATIONS_BROWSE_LINK,
  );
  return {
    browseTopStations,
  };
}

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      getBrowseDirectory: getInDomain('discovery.actions.getBrowseDirectory'),
    },
    dispatch,
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(MyStationsBrowseGenreCategories));
